import { render, staticRenderFns } from "./BusinessForm.vue?vue&type=template&id=00f445e4&"
import script from "./BusinessForm.vue?vue&type=script&lang=js&"
export * from "./BusinessForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessForm.vue?vue&type=style&index=0&id=00f445e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports